<template>
  <div class="research">
    <Header></Header>
    <!-- 研究报告 -->
    <div class="research_all">
      <!-- 上 -->
      <div class="research_all_block">
        <el-carousel trigger="click" height="480px">
          <el-carousel-item
            v-for="(item, index) in List_list"
            v-if="index < 4"
            :key="index"
          >
            <div
              class="research_all_swiper"
             
            >
             <a :href="item.url" target="_blank">
                <img class="research_all_swiper_img" :src="item.picture" alt="" />
              <div class="research_all_swiper_text">
                <div class="maters">
                  <div class="research_title">
                    {{ item.title }}
                  </div>
                  <div class="research_title1">
                    {{ item.info }}
                  </div>
                </div>
              </div>
             </a>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 下 -->
      <div class="research_botton">
        <div class="research_botton_serch">
          <el-input
            class="research_botton_serch_text"
            type="text"
            @keyup.enter.native="Go_search"
            placeholder="请输入搜索关键词"
            v-model="search"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <button class="research_botton_serch_button" @click="Go_search">
            搜索研报
          </button>
        </div>
        <!-- - 最新研报 - -->
        <!-- 前沿动态 -->
        <div class="Frontier_dynamics">
          <div class="title">
            <div class="title_zh">- 最新研报 -</div>
          </div>
          <div class="Frontier_dynamics_list">
            <div
              class="Frontier_dynamics_lists"
              v-for="(item, index) in newestreport"
              v-if="index < 4"
              :key="index"
              @click="Go_ResearchReportDetails(item.id)"
            >
              <div class="Frontier_dynamics_list_img_box">
                <img
                  class="Frontier_dynamics_list_img"
                  :src="item.img"
                  alt=""
                />
              </div>
              <div class="Frontier_dynamics_lists_bottom">
                <div class="Frontier_dynamics_lists_title">
                  {{ item.chinese_title }}
                </div>
                <div class="Frontier_dynamics_lists_content">
                  {{ item.report_profile }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- - 免费研报 - -->
        <div class="Research_Institute">
          <div class="title">
            <div class="title_zh">- 免费研报 -</div>
          </div>
          <div class="Research_Institute_box">
            <div
              class="Research_Institute_list"
              v-for="(item, index) in freereport"
              v-if="index < 8"
              :key="index"
              @click="Go_ResearchReportDetails(item.id)"
            >
              <img class="Research_Institute_list_img" :src="item.img" alt="" />
              <div class="Research_Institute_list_bottom">
                <div class="Research_Institute_list_title">
                  {{ item.chinese_title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Axios from "axios";
export default {
  metaInfo() {
    return {
      title: "研究报告_驱动中国研究院",
      meta: [
        {
          name: "keywords",
          content:
            "驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。",
        },
        {
          name: "description",
          content:
            " 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网",
        },
      ],
    };
  },
  name: "Research",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      search: "",
      images: [],
      search: "",
      newestreport: [], //最新研报
      freereport: [], //免费研报
      List_list: [],
    };
  },
  created() {
    this.newest();
    this.free();
    this.query();
  },
  methods: {
    query() {
      Axios({
        method: "get",
        url: "http://researchadmin.qudong.com/api/img_report",
      }).then((res) => {
        this.List_list = res.data.data;
      });
    },
    newest() {
      Axios({
        method: "get",
        url: "http://researchadmin.qudong.com/api/patent_index_one",
      }).then((res) => {
        this.newestreport = res.data.data;
      });
    },
    free() {
      Axios({
        method: "get",
        url: "http://researchadmin.qudong.com/api/patent_index_two",
      }).then((res) => {
        ////console.log(res.data.data);
        this.freereport = res.data.data;
      });
    },
    // 跳转研报详情
    Go_ResearchReportDetails(id) {
      this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
    },
    Go_search() {
      if (this.search == "") {
        return this.$message.warning("输入内容不能为空!");
      } else {
        this.$router.push({
          name: "Searchreport",
          query: { search: this.search },
        });
      }
    },
  },
};
</script>
<style scoped>
.research {
  width: 100%;
  margin: 0 auto;
}
.research_all {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 134px;
}
.research >>> .el-carousel__button {
  width: 40px;
  height: 8px;
}
/* 下面所有样式 */
.research_botton {
  width: 1200px;
  margin: 0 auto;
}
.research_botton_serch {
  display: flex;
  margin-top: 37px;
}
.research_botton_serch_text {
  width: 596px;
  height: 48px;
}
.research_botton_serch_button {
  width: 123px;
  height: 48px;
  background: #3463db;
  color: #ffffff;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
}
.research >>> .el-input__inner {
  height: 48px;
}
.Research_Institute .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.Research_Institute .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.Research_Institute .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.Research_Institute_box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 80px;
}
.Research_Institute_list_img {
  width: 288px;
  height: 180px;
  transition: all 0.6s;
}
.Research_Institute_list_bottom {
  padding: 18px;
}
.Research_Institute_list_title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.Research_Institute_list {
  margin-right: 15px;
  width: 288px;
  background: #fff;
  cursor: pointer;
}
.Research_Institute_list:nth-of-type(4n) {
  margin-right: 0px;
}
/* 前沿动态 */
.Frontier_dynamics .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.Frontier_dynamics .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.Frontier_dynamics .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}

.Frontier_dynamics_list {
  height: 333px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.Frontier_dynamics_lists {
  width: 288px;
  height: 332px;
  cursor: pointer;
  transition: background-color 0.5s linear, color 0.5s linear;
  -webkit-transition: background-color 0.5s linear, color 0.5s linear;
  -moz-transition: background-color 0.5s linear, color 0.5s linear;
  -o-transition: background-color 0.5s linear, color 0.5s linear;
}
.Frontier_dynamics_list_img_box {
  width: 288px;
  height: 180px;
  overflow: hidden;
}
.Frontier_dynamics_lists .Frontier_dynamics_list_img {
  width: 288px;
  height: 180px;
  transition: all 0.6s;
}
.Frontier_dynamics_list_img:hover {
  transform: scale(1.2);
}
.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content{
  color:#fff;
}
.Frontier_dynamics_lists:hover {
  background: #3463db;
  color: #fff;
}
.Frontier_dynamics_lists:hover {

  color: #fff;
}
.Frontier_dynamics_lists .Latest_patent_lists_img {
  width: 288px;
  height: 240px;
}

.Frontier_dynamics_lists_bottom {
  width: 288px;
  height: 140px;
}
.Frontier_dynamics_lists .Frontier_dynamics_lists_title {
 padding: 0px 20px;
    font-size: 20px;
    margin: 15px 0;
    font-family: PingFang SC;
    overflow: hidden;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: justify;
}
.Frontier_dynamics_lists .Frontier_dynamics_lists_content {
  padding: 0px 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color:#666;
  text-align:justify;
  line-height:24px;
  
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
/* 轮播图 */
.research_all_block {
  width: 100%;
}
.research_all_swiper {
  height: 100%;
  position: relative;
}
.research_all_swiper:hover {
  cursor: pointer;
}
.research_all_swiper_img {
  width: 100%;
  height: 100%;
  position: relative;
}
.research_all_swiper_text {
  width: 100%;
  height: 168px;
  background: #2c62cb;
  opacity: 0.9;
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.maters {
  width: 1139px;
  margin: 0 auto;
}
.research_title {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  margin-top: 29px;
  margin-bottom: 15px;
}
.research_title1 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>